import { render } from "./CardQuestions.vue?vue&type=template&id=61c78701"
import script from "./CardQuestions.vue?vue&type=script&lang=js"
export * from "./CardQuestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__